import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.editing}}
  <form class="form-horizontal">
    <div class="control-group">
      <Input
        {{on "input" this.onInput}}
        @value={{this.newUsername}}
        maxlength={{this.maxLength}}
        class="input-xxlarge username-preference__input"
      />

      <div class="instructions">
        <p>
          {{#if this.taken}}
            {{i18n "user.change_username.taken"}}
          {{/if}}
          <span>{{this.errorMessage}}</span>
        </p>
      </div>
    </div>

    <div class="control-group">
      <DButton
        @action={{this.changeUsername}}
        @disabled={{this.saveDisabled}}
        @translatedLabel={{this.saveButtonText}}
        type="submit"
        class="btn-primary username-preference__submit"
      />

      <DModalCancel @close={{this.toggleEditing}} />

      {{#if this.saved}}{{i18n "saved"}}{{/if}}
    </div>
  </form>
{{else}}
  <div class="controls">
    <span
      class="static username-preference__current-username"
    >{{@user.username}}</span>

    {{#if @user.can_edit_username}}
      <DButton
        @action={{fn this.toggleEditing @user}}
        @icon="pencil-alt"
        @title="user.username.edit"
        class="btn-small username-preference__edit-username"
      />
    {{/if}}
  </div>

  {{#if this.siteSettings.enable_mentions}}
    <div class="instructions">
      {{html-safe
        (i18n "user.username.short_instructions" username=@user.username)
      }}
    </div>
  {{/if}}
{{/if}}
*/
{
  "id": "lR5ixAaf",
  "block": "[[[41,[30,0,[\"editing\"]],[[[1,\"  \"],[10,\"form\"],[14,0,\"form-horizontal\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n      \"],[8,[39,1],[[16,\"maxlength\",[30,0,[\"maxLength\"]]],[24,0,\"input-xxlarge username-preference__input\"],[4,[38,2],[\"input\",[30,0,[\"onInput\"]]],null]],[[\"@value\"],[[30,0,[\"newUsername\"]]]],null],[1,\"\\n\\n      \"],[10,0],[14,0,\"instructions\"],[12],[1,\"\\n        \"],[10,2],[12],[1,\"\\n\"],[41,[30,0,[\"taken\"]],[[[1,\"            \"],[1,[28,[35,3],[\"user.change_username.taken\"],null]],[1,\"\\n\"]],[]],null],[1,\"          \"],[10,1],[12],[1,[30,0,[\"errorMessage\"]]],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n      \"],[8,[39,4],[[24,0,\"btn-primary username-preference__submit\"],[24,4,\"submit\"]],[[\"@action\",\"@disabled\",\"@translatedLabel\"],[[30,0,[\"changeUsername\"]],[30,0,[\"saveDisabled\"]],[30,0,[\"saveButtonText\"]]]],null],[1,\"\\n\\n      \"],[8,[39,5],null,[[\"@close\"],[[30,0,[\"toggleEditing\"]]]],null],[1,\"\\n\\n      \"],[41,[30,0,[\"saved\"]],[[[1,[28,[35,3],[\"saved\"],null]]],[]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"static username-preference__current-username\"],[12],[1,[30,1,[\"username\"]]],[13],[1,\"\\n\\n\"],[41,[30,1,[\"can_edit_username\"]],[[[1,\"      \"],[8,[39,4],[[24,0,\"btn-small username-preference__edit-username\"]],[[\"@action\",\"@icon\",\"@title\"],[[28,[37,6],[[30,0,[\"toggleEditing\"]],[30,1]],null],\"pencil-alt\",\"user.username.edit\"]],null],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"siteSettings\",\"enable_mentions\"]],[[[1,\"    \"],[10,0],[14,0,\"instructions\"],[12],[1,\"\\n      \"],[1,[28,[35,7],[[28,[37,3],[\"user.username.short_instructions\"],[[\"username\"],[[30,1,[\"username\"]]]]]],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null]],[]]]],[\"@user\"],false,[\"if\",\"input\",\"on\",\"i18n\",\"d-button\",\"d-modal-cancel\",\"fn\",\"html-safe\"]]",
  "moduleName": "discourse/components/username-preference.hbs",
  "isStrictMode": false
});